<template>
  <div class="sessionbox">
    <img src="/static/img/logo-icon.svg" />
    <h5 class="mb-0 mr-2 text">
      Starting your Nanome session
      <div class="ellipsis">{{ ellipsis }}</div>
    </h5>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: `Join Room - %s`
  },

  props: {
    b64RoomName: String
  },

  data: () => ({
    failTimeout: null,
    ellipsis: "...",
    ellipsisStage: 3,
    ellipsisID: null
  }),

  created() {
    this.ellipsisID = window.setInterval(this.animateEllipsis, 1000);

    window.addEventListener("blur", () => {
      window.clearTimeout(this.failTimeout);
    });

    let joinRoomCmd = { commands: [{ join: atob(this.b64RoomName) }] };
    let joinCmdStr = btoa(JSON.stringify(joinRoomCmd));

    this.failTimeout = setTimeout(() => {
      window.location = "https://nanome.ai/setup";
    }, 300);

    window.location = "nanome://" + joinCmdStr;
  },

  destroyed() {
    window.clearInterval(this.ellipsisID);
    window.clearTimeout(this.failTimeout);
  },

  methods: {
    animateEllipsis() {
      this.ellipsisStage = (this.ellipsisStage + 1) % 4;
      this.ellipsis = ".".repeat(this.ellipsisStage);
    }
  }
};
</script>

<style lang="scss">
.sessionbox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 20rem;
  width: 40rem;
  max-width: 90%;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
  background: white;

  img {
    width: 5rem;
    height: 5rem;
  }

  .ellipsis {
    display: inline-block;
    width: 0;
  }
}
</style>
